import{isHex as n}from"../data/isHex.js";function r(r){if(66!==r.length)return null;if(0!==r.indexOf("["))return null;if(65!==r.indexOf("]"))return null;const e=`0x${r.slice(1,65)}`;return n(e)?e:null}export{r as encodedLabelToLabelhash};
